<div ng-controller="registerCommentController as registerCommentCtrl" class="modal-view activity-details solo">
    <c-auto-form config="registerCommentCtrl.autoFormConfig"></c-auto-form>
</div>